<div class="empty-container" [ngClass]="{'small-screen': forceSmallScreen}">
    <img *ngIf="imgType == 'illustration'" src="../../../../assets/imgs/empty-state.svg" alt="Empty">
    <img *ngIf="imgType == 'icon'" src="../../../../assets/imgs/padlock.svg" alt="Padlock">
    <h3 class="title">{{title}}</h3>
    <p class="description">{{description}}</p>
    <div class="actions" *ngIf="hasPositiveAction || hasNegativeAction">
        <button
            *ngIf="hasNegativeAction"
            class="negative action-btn"
            (click)="negativeButtonClicked.emit()"
        >{{negativeButtonText}}</button>
        <button
            *ngIf="hasPositiveAction"
            class="positive action-btn"
            (click)="positiveButtonClicked.emit()"
        >{{positiveButtonText}}</button>
    </div>
    <p class="more-info" *ngIf="moreInfo">{{moreInfo}}</p>
</div>
